<template>
    <div>
        <span id="event-form" />
        <div uk-grid>
            <div class="uk-width-1-1">
                <div v-if="salutationErr" class="input-headline uk-form-danger">
                    Anrede ist ein Pflichtfeld.
                </div>
                <div v-else class="input-headline">Anrede</div>

                <div uk-grid>
                    <div>
                        <label class="cursor-pointer">
                            <input
                                v-on:click="salutationErr = false"
                                v-model="salutation"
                                class="uk-radio"
                                name="contact-option"
                                type="radio"
                                value="mrs" />
                            <span class="preferred-item">Frau</span>
                        </label>
                    </div>
                    <div>
                        <label class="cursor-pointer">
                            <input
                                v-on:click="salutationErr = false"
                                v-model="salutation"
                                class="uk-radio"
                                name="contact-option"
                                type="radio"
                                value="mr" />
                            <span class="preferred-item">Herr</span>
                        </label>
                    </div>
                    <div>
                        <label class="cursor-pointer">
                            <input
                                v-on:click="salutationErr = false"
                                v-model="salutation"
                                class="uk-radio"
                                name="contact-option"
                                type="radio"
                                value="hello" />
                            <span class="preferred-item">Hallo</span>
                        </label>
                    </div>
                </div>
            </div>

            <div
                v-for="(inputField, key) in textFields"
                :key="inputField.name"
                :class="inputField.width">
                <TextArea
                    v-if="inputField.type === 'textarea'"
                    v-model="inputField.value"
                    :autofocus="inputField.autofocus"
                    :field-key="key"
                    :icon="inputField.icon"
                    :label="inputField.label"
                    :name="inputField.name"
                    :required="inputField.required"
                    :rules="inputField.rules"
                    :type="inputField.type"
                    :validate="trigger"
                    @setValid="setValid" />
                <TextField
                    v-else
                    :disabled="inputField.disabled"
                    v-model="inputField.value"
                    :autocomplete="inputField.autocomplete"
                    :autofocus="inputField.autofocus"
                    :field-key="key"
                    :hasPasswordMeter="inputField.hasPasswordMeter"
                    :icon="inputField.icon"
                    :label="inputField.label"
                    :name="inputField.name"
                    :onEnter="inputField.onEnter"
                    :required="inputField.required"
                    :rules="inputField.rules"
                    :type="inputField.type"
                    :validate="trigger"
                    :is-optional="inputField.optional"
                    @setValid="setValid" />
            </div>

            <div v-if="false" class="uk-width-1-1">
                <div class="sepa-title">Hast Du eine Begleitung?</div>

                <div class="uk-margin-top" />
                <SwitchButton
                    switch-position
                    v-model="withPartner"
                    class="begleitung"
                    id="begleitung"
                    label="Mit Begleitung" />

                <div v-if="withPartner" class="uk-margin-top">
                    Deine Anmeldung wird mit Begleitung vermerkt.
                    <Icon
                        class="uk-form-success uk-margin-small-left"
                        icon="check" />
                </div>
            </div>

            <div class="uk-width-1-1">
                <div class="sepa-title">
                    Möchtest Du nach dem Event Fotos erhalten und bist
                    einverstanden, E-Mails zur Vereinsarbeit zu bekommem?
                </div>

                <div class="uk-margin-top" />
                <SwitchButton
                    switch-position
                    v-model="subscribe"
                    class="begleitung"
                    id="begleitung"
                    label="Event Fotos und E-Mails zur Vereinsarbeit" />

                <div v-if="subscribe" class="uk-margin-top">
                    Du erhältst Event Fotos und E-Mails zur Vereinsarbeit.
                    <Icon
                        class="uk-form-success uk-margin-small-left"
                        icon="check" />
                </div>
            </div>

            <div class="uk-width-1-1">
                <div class="sepa-title">
                    Möchtest Du ein Vereinsmagazin mit Informationen über den
                    Verein erhalten?
                </div>

                <div class="uk-margin-top" />
                <SwitchButton
                    switch-position
                    v-model="followUp"
                    class="begleitung"
                    id="begleitung"
                    label="Vereinsmagazin" />

                <div v-if="followUp" class="uk-margin-top">
                    Du erhältst ein Vereinsmagazin per Post mit Informationen
                    über den Verein.
                    <Icon
                        class="uk-form-success uk-margin-small-left"
                        icon="check" />

                    <div class="uk-margin-top" />
                    <div
                        class="uk-grid-small uk-child-width-1-2@m uk-child-width-1-1"
                        uk-grid>
                        <div
                            v-for="(inputField, key) in addressTextFields"
                            :key="inputField.name"
                            :class="inputField.width">
                            <TextField
                                :disabled="inputField.disabled"
                                v-model="inputField.value"
                                :autocomplete="inputField.autocomplete"
                                :autofocus="inputField.autofocus"
                                :field-key="key"
                                :hasPasswordMeter="inputField.hasPasswordMeter"
                                :icon="inputField.icon"
                                :label="inputField.label"
                                :name="inputField.name"
                                :onEnter="inputField.onEnter"
                                :required="inputField.required"
                                :rules="inputField.rules"
                                :type="inputField.type"
                                :validate="trigger"
                                :is-optional="inputField.optional"
                                @setValid="setValidAddress" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-margin-medium-top" />
        <div class="uk-text-center">
            <Button
                text="Anmelden"
                is-large
                is-min-width
                :is-loading="loading"
                has-action
                :action="contact"
                mode="success" />
        </div>

        <div v-if="!invite.slots" class="uk-margin-medium-top" />
        <hr v-if="!invite.slots" />

        <div v-if="!invite.slots" class="uk-text-center">
            <Button
                text="Absagen"
                is-min-width
                uk-toggle="target: #modal-deny"
                mode="default" />
        </div>
        <Modal id="modal-deny" title="Einladung absagen">
            <div class="uk-text-center">
                Möchtest du wirklich die Einladung absagen?
            </div>

            <div class="uk-margin-medium-top" />
            <div uk-grid class="uk-grid-small uk-flex-center">
                <div>
                    <Button
                        text="Abbrechen"
                        is-large
                        is-min-width
                        class="uk-modal-close"
                        mode="default" />
                </div>
                <div>
                    <Button
                        class="uk-modal-close"
                        text="Absagen"
                        is-large
                        is-min-width
                        :is-loading="denyLoading"
                        has-action
                        :action="contactDeny"
                        mode="danger" />
                </div>
            </div>
        </Modal>

        <div v-if="error" class="uk-margin-medium-bottom" />
        <ErrorMessage
            :custom-errors="[
                {code: 400, message: 'Die E-Mail Adresse ist ungültig.'},
                {
                    code: 412,
                    message:
                        'Für die angegebene E-Mail-Adresse existiert bereits eine andere Einladung.',
                },
            ]"
            :error="error" />
    </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/Button';
import TextField from '@/components/TextField';
import TextArea from '@/components/TextArea';
import SwitchButton from '@/components/SwitchButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Icon from '../../components/Icon.vue';
import UIkit from 'uikit';
import Modal from '@/components/Modal.vue';

export default {
    name: 'EventForm',
    components: {
        Modal,
        Icon,
        ErrorMessage,
        SwitchButton,
        TextArea,
        TextField,
        Button,
    },
    props: {
        invite: Object,
    },
    data() {
        return {
            trigger: 0,
            textFields: [
                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'forename',
                    label: 'forename',
                    rules: 'required',
                    icon: 'user',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                    disabled: false,
                },
                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'surname',
                    label: 'surname',
                    rules: 'required',
                    icon: 'users',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                    disabled: false,
                },

                {
                    value: '',
                    valid: false,

                    name: 'emailAddress',
                    label: 'emailAddress',
                    rules: 'required|email',
                    icon: 'mail',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                    disabled: false,
                },
            ],

            salutation: '',
            salutationDisabled: false,
            salutationErr: false,
            withPartner: false,
            subscribe: true,
            followUp: false,

            error: null,
            loading: false,
            success: false,

            denyLoading: false,

            addressTextFields: [
                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'street',
                    label: 'street',
                    rules: 'required',
                    icon: 'home',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                },
                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'streetNumber',
                    label: 'streetNumber',
                    rules: 'required',
                    icon: 'tag',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                },

                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'zip',
                    label: 'zip',
                    icon: 'location',
                    rules: 'required|numeric|max:320',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                },
                {
                    autofocus: false,

                    value: '',
                    valid: false,
                    name: 'city',
                    label: 'city',
                    icon: 'world',
                    rules: 'required|max:320',
                    width: 'uk-width-1-2@s uk-width-1-1',
                    required: true,
                },
            ],
        };
    },
    created() {
        if (this.invite.email) {
            this.textFields[2].value = this.invite.email;
            this.textFields[2].valid = true;
            this.textFields[2].disabled = true;
        }

        if (this.invite.forename) {
            this.textFields[0].value = this.invite.forename;
            this.textFields[0].valid = true;
            //this.textFields[0].disabled = true;
        }

        if (this.invite.surname) {
            this.textFields[1].value = this.invite.surname;
            this.textFields[1].valid = true;
            //this.textFields[1].disabled = true;
        }

        if (this.invite.salutation) {
            this.salutation = this.invite.salutation;
            //this.salutationDisabled = true;
        }

        this.$forceUpdate();
    },
    methods: {
        setValidAddress(valid, fieldKey) {
            this.addressTextFields[fieldKey].valid = valid;
        },
        setValid(valid, fieldKey) {
            this.textFields[fieldKey].valid = valid;
        },
        contactDeny() {
            this.denyLoading = true;

            let http = axios.create();
            http.post(
                this.getBaseUrl + '/api/invites/deny',
                {},
                {
                    headers: {
                        token: this.$route.query.token,
                    },
                }
            )
                .then(() => {
                    this.denyLoading = false;
                    this.$emit('denied', true);
                })
                .catch(() => {
                    this.denyLoading = false;
                });
        },
        contact() {
            this.trigger++;

            if (!this.salutation) {
                this.salutationErr = true;
                UIkit.scroll('#event-form', {offset: 100}).scrollTo(
                    '#event-form'
                );
                return;
            }
            this.salutationErr = false;

            for (let i = 0, j = this.textFields.length; i < j; i++) {
                if (!this.textFields[i].valid) {
                    UIkit.scroll('#event-form', {offset: 100}).scrollTo(
                        '#event-form'
                    );
                    return;
                }
            }

            if (this.followUp) {
                for (let i = 0, j = this.addressTextFields.length; i < j; i++) {
                    if (!this.addressTextFields[i].valid) {
                        UIkit.scroll('#event-form', {offset: 100}).scrollTo(
                            '#event-form'
                        );
                        return;
                    }
                }
            }

            let street = undefined;
            let streetNumber = undefined;
            let zip = undefined;
            let city = undefined;

            if (this.followUp) {
                street = this.addressTextFields[0].value;
                streetNumber = this.addressTextFields[1].value;
                zip = this.addressTextFields[2].value;
                city = this.addressTextFields[3].value;
            }

            this.loading = true;

            let targetUrl = 'accept';
            if (this.invite.slots && this.invite.slots > 0) {
                targetUrl = 'self';
            }

            let http = axios.create();
            http.post(
                this.getBaseUrl + '/api/invites/' + targetUrl,
                {
                    salutation: this.salutation,
                    forename: this.textFields[0].value,
                    surname: this.textFields[1].value,
                    email: this.textFields[2].value,
                    partner: this.withPartner,
                    subscribe: this.subscribe,

                    street,
                    streetNumber,
                    zip,
                    city,
                },
                {
                    headers: {
                        token: this.$route.query.token,
                    },
                }
            )
                .then(() => {
                    this.error = null;
                    this.success = true;
                    this.loading = false;

                    this.$emit('success', true);
                    this.$emit('forename', this.textFields[0].value);
                })
                .catch((e) => {
                    this.error = e;
                    this.success = false;
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.loading {
    height: 50px !important;
}

.feedback-thanks {
    font-size: 18px;
    height: 50px;
}

.contribution {
    font-weight: 500;
    font-size: 48px;
    color: #fff !important;
}

.uk-card-success {
    background-color: #0d5746 !important;
    box-shadow: 0 14px 25px rgba(0, 0, 0, 0.16);
}

.hint-2 {
    margin-top: 20px;
    font-size: 14px;
}

.unified-modifiers {
    width: 110px;
}

.sepa-title {
    font-weight: 500;
    margin-top: 5px;
}

.begleitung {
    width: 200px;
}
</style>
